import { apply, pipeable } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
export * from 'fp-ts/Chain';
/**
 * Combination of `bind` and `sequenceS`.
 *
 * @example
 *
 * const a = pipe(
 *   option.some({
 *     foo: 1
 *   }),
 *   option.bindS(({ foo }) => ({
 *     bar: option.some(foo + 1),
 *     baz: option.some(foo + 2)
 *   }))
 * )
 *
 * assert.deepStrictEqual(a, option.some({ foo: 1, bar: 2, baz: 3 }))
 */
export const bindSequenceS = (F) => (f) => pipeable.chain(F)((a) => pipe(apply.sequenceS(F)(f(a)), pipeable.map(F)((b) => ({ ...a, ...b }))));
/**
 * Variant of bind that takes multiple bindings at one. Similar to {@link bindSequenceS}, but
 * without the sequencing.
 *
 * @example
 *
 * const a = pipe(
 *   option.some({
 *     foo: 1
 *   }),
 *   option.bindS(({ foo }) => option.some({
 *     bar: foo + 1,
 *     baz: foo + 2
 *   }))
 * )
 *
 * assert.deepStrictEqual(a, option.some({ foo: 1, bar: 2, baz: 3 }))
 */
export const bindS = (F) => (f) => pipeable.chain(F)((a) => pipe(f(a), pipeable.map(F)((b) => ({ ...a, ...b }))));
/**
 * Combination of `chain` and `sequenceS`.
 *
 * @example
 *
 * const a = pipe(
 *   option.some({
 *     foo: 1
 *   }),
 *   option.chainSequenceS(({ foo }) => ({
 *     bar: option.some(foo + 1),
 *     baz: option.some(foo + 2)
 *   }))
 * )
 *
 * assert.deepStrictEqual(a, option.some({ bar: 2, baz: 3 }))
 */
export const chainSequenceS = (F) => (f) => pipeable.chain(F)(flow(f, apply.sequenceS(F)));
//# sourceMappingURL=chain.js.map